import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Input from '../../components/Input';
import TourBlock from './components/TourBlock';
import "./CityPage.scss";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeSearchCategory = this.handleChangeSearchCategory.bind(this);
    this.getTourById = this.getTourById.bind(this);
    this.state = {
      error: {},
      peopleNumber: '',
      searchCategoryValues: [],
      searchDate: null,
    }
  }

  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    cities: PropTypes.array,
    categories: PropTypes.array,
    searchSelectedCity: PropTypes.number,
    getTours: PropTypes.func,
    tours: PropTypes.array,
    filterTours: PropTypes.array,
    othersTours: PropTypes.array,
    getTourById: PropTypes.func,
    onFilterTours: PropTypes.func,
    searchPageUnMounted: PropTypes.func,
    promiseGetTours: PropTypes.object,
  };

  componentWillMount() {
    const {params} = this.props.match;
    if (params && params.id) {
      this.props.getTours({cityId: +params.id})
    }
  }

  componentWillUnmount() {
    this.props.searchPageUnMounted()
  }

  componentWillReceiveProps() {
  }

  setSelectedCityName() {
    const {cities, searchSelectedCity} = this.props;
    for (let i = 0; i < cities.length; i++) {
      if (+cities[i].id === +searchSelectedCity) {
        return cities[i].city
      }
    }
    return null;
  }

  createCategoriesOptions() {
    const {categories} = this.props;
    const result = [];
    for (let i = 0; i < categories.length; i++) {
      result.push(
        {value: categories[i].id, label: categories[i].name}
      )
    }
    return result
  }

  getTourById(id) {
    this.props.getTourById(id, this.props.history)
  }

  handleChangeInput(e) {
    let {value} = e.target;
    if (value && Number.isNaN(value)) {
      return
    }
    if (value.length > 5) {
      this.setState({error: {peopleNumber: 'Max length 10000'}});
      return
    }
    if (!value.match(/[0-9]/)) {
      value = '';
    } else
      value = Math.round(value);
    if (!value) {
      value = ''
    }
    this.setState({
      peopleNumber: +value
    }, () => {
      this.setState({error: {}});
      this.props.onFilterTours(this.state.searchCategoryValues.map((item) => {
        return item.value
      }), this.state.peopleNumber, this.state.searchDate)
    });
  }

  handleChangeSearchCategory(searchCategoryValues) {
    this.setState({searchCategoryValues}, () => {
      this.props.onFilterTours(this.state.searchCategoryValues.map((item) => {
        return item.value
      }), this.state.peopleNumber, this.state.searchDate)
    })
  }

  handleChangeDate = (e) => {
    this.setState({searchDate: e}, () => {
      this.props.onFilterTours(this.state.searchCategoryValues.map((item) => {
        return item.value
      }), this.state.peopleNumber, this.state.searchDate)
    });
  };

  render() {
    const {
      tours,
      othersTours,
      filterTours,
      promiseGetTours,
    } = this.props;

    const {
      error,
      peopleNumber,
      searchCategoryValues,
      searchDate,
    } = this.state;

    return (
      <div className="city-page">
        <h2 className="city-page__title"><span>Welcome to</span> {this.setSelectedCityName()}</h2>
        {
          tours.length === 0 && promiseGetTours.isSuccess ?
            <div className="city-page__placeholder">
              <p className="city-page__placeholder-title">
                <span>No available tours in</span> {this.setSelectedCityName()} <span>right now</span>
              </p>
              <img
                src="/assets/img/placeholder.png"
                alt="placeholder"
              />
            </div> :
            <div>
              {
                othersTours.length === 0 && promiseGetTours.isPending ?
                  null :
                  <div>
                    <div className="city-page__filters">
                      <div className="city-page__filters-group">
                        <Input
                          type="text"
                          label="Find a tour for"
                          subTitle="people"
                          value={peopleNumber}
                          error={error.peopleNumber}
                          onChange={(e) => this.handleChangeInput(e)}
                          placeholder="0"
                        />
                        <div className="input-block city-page__filters-date">
                          <span className="input-block__label">Find a tour by date</span>
                          <div className="city-page__filters-block">
                            <DatePicker
                              selected={searchDate}
                              onChange={this.handleChangeDate}
                              locale="en-gb"
                            />
                          </div>
                        </div>
                      </div>
                      <Select
                        clearable={false}
                        multi
                        name="category"
                        value={searchCategoryValues}
                        placeholder="Category"
                        onChange={this.handleChangeSearchCategory}
                        options={this.createCategoriesOptions()}
                      />
                    </div>
                    <div className="city-page__tours">
                      {
                        filterTours.length > 0 ?
                          <div>
                            <ul className="tour__list">
                              {
                                filterTours.map((tour) => {
                                  return (
                                    <TourBlock
                                      key={`home-tour-${tour.id}`}
                                      {...tour}
                                      getTourById={this.getTourById}
                                    />
                                  )
                                })
                              }
                            </ul>
                          </div> :
                          <div className="city-page__search-result">
                            <div className="city-page__title-block">
                              <h3>No search results</h3>
                              <img src="/assets/img/no-results.png" alt="no-results" />
                            </div>
                          </div>
                      }
                      {
                        othersTours.length > 0 ?
                          <div className="city-page__title-block">
                            <h3 className="city-page__title-other">Other tours you might be interested in</h3>
                          </div> : null
                      }
                      <ul className="tour__list city-page__tours-other">
                        {
                          othersTours.map((tour) => {
                            // console.log(tour);
                            return (
                              <TourBlock
                                key={`home-tour-${tour.id}`}
                                {...tour}
                                getTourById={this.getTourById}
                              />
                            )
                          })
                        }
                      </ul>
                    </div>
                  </div>
              }
            </div>
        }
      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/app/containers/SearchResult/Component.js